<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="payroll-adustments-review" color="white"></help-link>
                    <div v-if="manual_adjustment">
                        <v-menu v-if="hasEditAndApproverRights" left v-model="menu_status" offset-y :disabled="disabledForEditApprover"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(manual_adjustment.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(manual_adjustment.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="0" @click="showEdit" title="Edit Payroll Adjustment">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(created_status||rejected_status)" :key="1" @click="dialogDelete=true" title="Delete Payroll Adjustment">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&created_status" :key="2" @click="forReview" title="Set Status to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Payroll Adjustment">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditAndApproverRights&&(forReview_status||approved_status)" :key="4" @click="reject" title="Reject Payroll Adjustment">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                        <v-menu v-if="!hasEditAndApproverRights&&(hasEditRights||hasApproverRights)" left v-model="menu_status" offset-y :disabled="disabledForEdit||disabledForApprover"> 
                            <template v-slot:activator="{ on }">
                                <v-btn :color="commonfn.getStatusButtonColor(manual_adjustment.status)" dark v-on="on" :loading="loading_status">
                                    &nbsp;&nbsp;&nbsp;{{commonfn.getStatusDescription(manual_adjustment.status)}}&nbsp;&nbsp;
                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense >
                                <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" :key="0" @click="showEdit" title="Edit Payroll Adjustment">
                                    <v-list-tile-title small>Edit</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditRights&&(created_status||rejected_status)" :key="1" @click="dialogDelete=true" title="Delete Payroll Adjustment">
                                    <v-list-tile-title small>Delete</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasEditRights&&created_status" :key="2" @click="forReview" title="Set Status to For Review">
                                    <v-list-tile-title small>For Review</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasApproverRights&&(forReview_status||rejected_status)" :key="3" @click="approve" title="Approve Payroll Adjustment">
                                    <v-list-tile-title small>Approve</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status)" :key="4" @click="reject" title="Reject Payroll Adjustment">
                                    <v-list-tile-title small>Reject</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>

            <v-alert v-if="!loading&&processed_status" :value="true" color="info" icon="info" outline style="margin-top:10px;">
                The payroll adjustment has been <b>Processed</b> already. You will not be able to change this record.
            </v-alert>
            <v-alert v-if="!loading&&!processed_status" :value="true" color="info" icon="info" outline dismissible>
                Only <b>Approved</b> adjustments will be included in payroll processing.
            </v-alert>  

            <!-- details -->
            <v-card v-if="!loading" class="elavation-1" style="margin-top:10px;margin-bottom:5px;">
                <v-toolbar flat height="35px" class="font-weight-bold">
                    <span>Adjustment Details</span>
                    <v-spacer></v-spacer>
                </v-toolbar>                
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:10px 20px 0px 20px;' : 'padding:10px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Requested By :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <v-chip @click="viewUserProfile(manual_adjustment, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(manual_adjustment.userId)"></v-img>
                                    </v-avatar>
                                    {{manual_adjustment.firstName}} {{manual_adjustment.lastName}}
                                </v-chip>
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Created On :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{manual_adjustment.createdOn|moment('dddd, DD MMM YYYY')}}
                            </v-flex>  
                        </v-layout>      
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Journal Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                               {{manual_adjustment.transType==1?'Credit to Payroll':'Debit to Payroll'}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Adjustment Type :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                               {{manual_adjustment.manualAdjustmentName}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Taxable Income Computation :
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                <span v-if="manual_adjustment.transType==1">
                                    <span v-if="manual_adjustment.addToTaxableIncome">Included in taxable income</span>
                                    <span v-else>Not included in taxable income</span>
                                </span>
                                <span v-else>
                                    <span v-if="manual_adjustment.deductFromTaxableIncome">Deducted from taxable income</span>
                                    <span v-else>Not deducted from taxable income</span>
                                </span>
                            </v-flex>  
                        </v-layout>
                         <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Amount : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                PHP {{numFormat.formatNumber(manual_adjustment.amount)}}
                            </v-flex>  
                        </v-layout>
                         <v-layout row wrap :style="isMobile? 'padding:0px 20px 0px 20px;' : 'padding:0px 20px 0px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Process Period : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                {{getCoverageDesc}}
                            </v-flex>  
                        </v-layout>
                        <v-layout row wrap :style="isMobile? 'padding:0px 20px 10px 20px;' : 'padding:0px 20px 10px 50px;'"> 
                            <v-flex xs4 class="text-xs-left">
                                Remarks : 
                            </v-flex>
                            <v-flex xs8 class="font-weight-bold text-xs-left">
                                 {{manual_adjustment.remarks}}
                            </v-flex>  
                        </v-layout>
                    </v-flex>
                </v-layout>              
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="dialogDelete" width="500">
            <v-card class="elavation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold ">Confirm Delete</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="text-xs-center">
                    <p>Delete this Payroll Adjustment?</p>
                    <p>Note: you will not be able to undo this operation.</p>
                </v-card-text>
                 <v-divider></v-divider>
                 <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn title="Delete" class="red" dark @click="deleteManualAdjustment" :loading="loading_delete">Delete</v-btn>
                    <v-btn title="Cancel" @click="dialogDelete=false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogManualAdjustments" width="600" persistent>   
            <adjustments ref="adjustmentsRef" :dialogManualAdjustments.sync="dialogManualAdjustments" @send="getManualAdjustments(false)"></adjustments>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>
<script>

import commonfn from '@/common/functions'
import manualAdjustmentsApi from '@/api/manualadjustments'
import numFormat from '@/common/num_format'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import awsS3Helper from '@/helpers/aws-s3'

export default {     
    name: 'Adjustments',
    metaInfo: {
        title: 'Adjustments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View, create Manual Adjustments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'adjustments': () => import('@/components/Payroll/ManualAdjustments'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
      return {
        error: false,
        errorMessage: '',
        dialogDelete: false,
        menu_status: false,
        loading: false,
        loading_status: false,
        loading_delete: false,
        snackbar: false,
        snackbarText: '',
        message: null,
        dialogManualAdjustments: false,
        manual_adjustment: null,
        cutoff_period: null,
      }
    },
    methods: {  
        async forReview() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.forReview(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.reject(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try{
                this.loading_status = true
                const response = await manualAdjustmentsApi.approve(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    await this.getManualAdjustments(false)
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deleteManualAdjustment() {
            try{
                this.loading_delete = true
                await manualAdjustmentsApi.delete(this.manualAdjustmentId)
                this.loading_delete = false
                this.dialogDelete = false
                this.$router.push(`/payroll/adjustments/${this.cutoff_period.cutoffId}`)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        showEdit() {
            this.$refs.adjustmentsRef.setUpdate(this.manual_adjustment)
            this.dialogManualAdjustments = true
        },
        async getManualAdjustments(show_loading){
            try{
                if (show_loading) this.loading = true
                const response = await manualAdjustmentsApi.getById(this.manualAdjustmentId)
                if (response && response.status == 200) {
                    this.manual_adjustment = response.data.manualAdjustment
                    this.cutoff_period = response.data.cutoffItem
                }
                if (show_loading) this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getManualAdjustments(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        this.commonfn = commonfn
        this.numFormat = numFormat
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Adjustments Details'
        })
        this.getManualAdjustments(true)
    },
    computed: {
        pageQueryId() {
            return `adjustment${this.manualAdjustmentId}`
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        manualAdjustmentId() {
            return this.$route.params.manualAdjustmentId
        },
        commentsData() {
            if (this.manual_adjustment) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: this.manual_adjustment.userId,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.manual_adjustments,
                    notificationTypeId: notificationTypes.manual_adjustments
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        getCoverageDesc() {
            return this.$moment(this.cutoff_period.cutoffStart).format('MMM DD, YYYY') + ' - ' + this.$moment(this.cutoff_period.cutoffEnd).format('MMM DD, YYYY')
        },
        frozenPeriod(){
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod(){
            if (this.cutoff_period)
                return this.cutoff_period.status==commonfn.getStatusCode('Closed')
        },
        created_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status==commonfn.getStatusCode('Created')
        },
        forReview_status() {
            if (this.manual_adjustment)
                return this.manual_adjustment.status==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.manual_adjustment)
            return this.manual_adjustment.status==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.manual_adjustment)
            return this.manual_adjustment.status==commonfn.getStatusCode('Rejected')
        },
        processed_status() {
            if (this.manual_adjustment)
            return this.manual_adjustment.status==commonfn.getStatusCode('Processed')
        },
        approved_Timesheet() {
            if (this.cutoff_period)
                return this.cutoff_period.timeReportStatus==commonfn.getStatusCode('Approved')
        },
        disabledForEdit() {
            return this.hasEditRights&&(this.forReview_status||this.approved_status||this.processed_status)
        },
        disabledForApprover() {
            return this.hasApproverRights&&(this.created_status||this.processed_status)
        },
        disabledForEditApprover() {
            return this.processed_status
        }
    }
}
</script>